import React, { useCallback, useEffect, useRef, useState } from 'react';
import WfButton from './WfButton';

interface ContextMenuProps {
	target?: { x: number; y: number } | null;
	className?: string;
	itemRow?: any;
	handleCloseMenu?: any;
	actionClick?: any;
	tracker: string;
	objectId: string;
	ButtonProps?: any;
	additionalFunc?: (currStatusId?: string | undefined, codeButton?: string | undefined) => void;
	handleClick?: (props: WfAction) => void;
	additionalProps?: any;
	forceRender?: boolean;
	prefixFunction?: (
		currentStatusCode: string,
		wfCallbackFn: () => void | Promise<any>,
		cancel?: () => void,
		listResponse?: {}
	) => void | Promise<any>;
	getTrackerField?: (fields: any) => void;
	hiddenWfButton?: boolean;
	componentName?: string;
}

interface WfAction {
	componentName: string;
	nameReq: string;
	cancel?: () => void;
	submit: () => void;
}

const WfContextMenu: React.FC<ContextMenuProps> = (
	ContextMenuProps: ContextMenuProps
) => {
	const menuRefInner = useRef<any>(null);
	const [targetMenu, setTargetMenu] = useState<any>(ContextMenuProps?.target);

	useEffect(() => {
		if (ContextMenuProps?.target) {
			const menuWidth = menuRefInner.current?.clientWidth;
			const menuHeight = menuRefInner.current?.clientHeight;
			const screenWidth = window.innerWidth;
			const screenHeight = window.innerHeight;
			let newTarget = { ...ContextMenuProps?.target };

			if (ContextMenuProps?.target.x + menuWidth > screenWidth) {
				newTarget = { ...newTarget, x: screenWidth - menuWidth - 50 };
			}

			if (ContextMenuProps?.target.y + menuHeight > screenHeight) {
				newTarget = { ...newTarget, y: screenHeight - menuHeight - 50 };
			}

			setTargetMenu(newTarget);
		}
	}, [ContextMenuProps?.target]);

	const closeMenu = useCallback(
		(event: MouseEvent) => {
			if (targetMenu && !menuRefInner.current?.contains(event.target as Node)) {
				ContextMenuProps?.handleCloseMenu?.();
			}
		},
		[ContextMenuProps?.handleCloseMenu, targetMenu]
	);

	useEffect(() => {
		document.addEventListener('click', closeMenu);

		return () => {
			document.removeEventListener('click', closeMenu);
		};
	}, [closeMenu]);

	const renderMenu = () => {
		return (
			<ul ref={menuRefInner} className="m-0 p-0 drop-list-container spaces W-200">
				<WfButton {...ContextMenuProps} isContextMenu={true} />
			</ul>
		);
	};

	return (
		<div
			style={{ top: targetMenu?.y ?? 0, left: targetMenu?.x ?? 20 }}
			className={`position-fixed ${ContextMenuProps?.className} z-index-1060 spaces`}
		>
			<div className="border">{targetMenu && renderMenu()}</div>
		</div>
	);
};

export default WfContextMenu;
